import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// nodejs library to set properties for components
import PropTypes from "prop-types";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
// @material-ui/icons

// core components
import styles from "assets/jss/material-dashboard-react/components/cardHeaderStyle.js";

const useStyles = makeStyles(styles);

export default function CardHeader(props) {
  const classes = useStyles();
    const { className, children, color, plain, stats, icon, customColor, borderRadius, style, ...rest } = props;
  const cardHeaderClasses = classNames({
    [classes.cardHeader]: true,
    [classes[color + "CardHeader"]]: color && !customColor, // ���շ���˹��ҡ prop �������� customColor
    //[classes[color + "CardHeader"]]: color,
    [classes.cardHeaderPlain]: plain,
    [classes.cardHeaderStats]: stats,
    [classes.cardHeaderIcon]: icon,
    [className]: className !== undefined
  });
  return (
      <div
          className={cardHeaderClasses}
          style={{
              background: customColor ? customColor : undefined,
              borderRadius: borderRadius || "6px", // ��˹���� borderRadius �������ö��Ѻ��
              ...style // ���������� � ����������
          }}
          
          {...rest}
      >
          {children}
      </div>
  );
}

CardHeader.propTypes = {
  className: PropTypes.string,
  color: PropTypes.oneOf([
    "warning",
    "success",
    "danger",
    "info",
    "primary",
    "rose"
  ]),
  plain: PropTypes.bool,
  stats: PropTypes.bool,
  icon: PropTypes.bool,
  customColor: PropTypes.string, // ��˹� customColor �� string
  style: PropTypes.object, // ������Ѻ inline styles
  borderRadius: PropTypes.string, // Prop ����Ѻ��Ѻ borderRadius
  children: PropTypes.node
};
